import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { OrderActionTypes, OrderActions } from '@ordersnproducts/modules/new-modify-order/actions/order.actions';

export interface OrderState {
  loading: boolean;
  orderResponse: any;
  orderCode: string;
  orderId: number;
  loadingValidateDateTimePlant: boolean;
  validateDateTime: string;
  productQuantity: number;
}

export const initialState: OrderState = {
  loading: false,
  orderResponse: null,
  orderCode: null,
  orderId: null,
  loadingValidateDateTimePlant: false,
  validateDateTime: null,
  productQuantity: null,
};

export function orderReducer(state = initialState, action: OrderActions | OrderBuilderActions): OrderState {
  switch (action.type) {
    case OrderActionTypes.LOAD_PLANT_DATE_TIME: {
      return {
        ...state,
        loadingValidateDateTimePlant: true,
      } as OrderState;
    }
    case OrderActionTypes.SET_PLANT_DATE_TIME: {
      return {
        ...state,
        loadingValidateDateTimePlant: false,
        validateDateTime: action.payload,
      } as OrderState;
    }
    case OrderActionTypes.SET_ORDER: {
      return {
        ...state,
        orderCode: action.payload,
      } as OrderState;
    }
    case OrderActionTypes.SET_ORDER_ID: {
      return {
        ...state,
        orderId: action.payload,
      } as OrderState;
    }
    case OrderActionTypes.REQUEST: {
      return {
        ...state,
        loading: true,
      } as OrderState;
    }
    case OrderActionTypes.REQUEST_OP: {
      return {
        ...state,
        loading: true,
      } as OrderState;
    }
    case OrderActionTypes.REQUEST_COMPLETE: {
      return {
        ...state,
        loading: false,
        orderResponse: action.payload,
      } as OrderState;
    }
    case OrderActionTypes.SET_QUANTITY_MODIFY: {
      return {
        ...state,
        productQuantity: action.payload,
      } as OrderState;
    }
    case RESET_BUILDER:
    case OrderActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
